import * as React from "react"

const iconColor = {
  color: "#e8540e",
}

const Social = () => {
  return (
    <li className="nav-item list-unstyled d-none d-lg-block">
      <nav className="nav social justify-content-end text-end">
        <a href="https://twitter.com/com2com_nv">
          <i className="uil uil-twitter" style={iconColor} />
        </a>

        <a href="https://www.facebook.com/COM2COM.nv">
          <i className="uil uil-facebook-f" style={iconColor} />
        </a>

        <a href="https://www.youtube.com/channel/UC9zgLTmMqxD4sbd-H9It9Iw">
          <i className="uil uil-youtube" style={iconColor} />
        </a>

        <a href="https://www.linkedin.com/company/com2com/">
          <i className="uil uil-linkedin" style={iconColor} />
        </a>

        <a href="https://www.instagram.com/com2com_nv/">
          <i className="uil uil-instagram" style={iconColor} />
        </a>
      </nav>
    </li>
  )
}

export default Social
